<template>
    <b-table-simple hover responsive class="mr-3">
        <b-thead>
            <b-tr>
                <b-th class="part-list-line align-top">
                    <div class="d-flex justify-content-start flex-row">
                        <div>Line</div>
                    </div>
                </b-th>
                <b-th class="part-list-part-name align-top">
                    <div class="d-flex justify-content-start flex-row">
                        <div>Part Name</div>
                        <span class="sort-icon" v-on:click="supplierPrice.sortBy('name')"></span>
                    </div>
                </b-th>
                <b-th class="part-list-number align-top">
                    Part Number
                    <span class="sort-icon" v-on:click="supplierPrice.sortBy('number')"></span>
                </b-th>
                <b-th class="part-list-qty align-top">
                    <div class="d-flex justify-content-center flex-row">
                        <div class="div-qty">List</div>
                        <span class="sort-icon" v-on:click="supplierPrice.sortBy('rrp')"></span>
                    </div>
                </b-th>
                <b-th class="part-list-qty align-top">
                    <div class="d-flex justify-content-center flex-row">
                        <div class="div-qty">Qty</div>
                        <span class="sort-icon" v-on:click="supplierPrice.sortBy('qty')"></span>
                    </div>
                </b-th>

                <b-th class="part-list-supplier text-center align-top" v-for="supplier in supplierPrice.selectedSuppliers"
                      :key="supplier.orderId">
                    <div class="supplier-icon text-center font-20"><i class='bx bx-car'></i></div>
                    <div class="supplier-name text-center">{{ supplier.name }}</div>
                    <div class="supplier-type text-center">{{ supplier.type }}</div>
                </b-th>
            </b-tr>
        </b-thead>
        <b-tbody>
            <b-tr v-for="(part, index) in allPartsSomebodySelected" :key="part.id">
                <b-td class="part-list-line align-top font-12 font-weight-normal text-center">
                    {{ index + 1 }}
                </b-td>
                <b-td class="part-list-part-name align-top font-12 font-inter--bold"
                      :class="{'linked': partIsLinked(part)}" >
                    <div class="part-list-part-name__group">
                        <div :class="{'part-list-item-alt-name': !part.isOriginalPart, 'part-list-item-name-original-original-linked': part.isOriginalPart && partIsLinked(part)}" class="part-list-part-name__name">{{ part.name }}</div>
                        <div class="part-list-part-name__alt">{{ getAltPartName(part.id) }}</div>
                    </div>
                    <!-- icons -->
                    <!-- <div class="part-list-part-name__icon-group">
                        <i v-if="partIsLinked(part)"
                            class='bx bx-link part-list-part-name__icon'
                            v-b-tooltip.hover="{customClass: 'ps-tooltip', html: true, title:`Linked to <br>${getPartLinkedName(part)}`, placement:'leftbottom'}"
                            ></i>
                    </div> -->
                    <div v-if="part.isDelivery" class="part-list-item-number font-12 ">{{ part.number ? part.number : '' }}</div>
                </b-td>

                <b-td class="part-list-number text-center align-top font-weight-bold" style="padding-right: 0px !important; padding-left: 0px !important;">
                    <div v-if="part.number === getPartNumber(part.id) || isEmpty(getPartNumber(part.id))" class="part-list-item-number font-12">
                      {{ part.number }}
                    </div>
                    <div v-else class="part-list-item-number font-12">
                      {{ getPartNumber(part.id) }}
                    </div>

                  <div
                      v-b-tooltip.hover="{customClass: 'ps-tooltip custom-tooltip-position', html: true, title: getStockCommentFull(part.id), placement:'bottom'}"
                      :class="{
                     'part-number-stock-orange': getIsHasExOrBackComment(part.id).ex,
                     'part-number-stock-red': getIsHasExOrBackComment(part.id).back,
                    }"
                      style="overflow: hidden"
                  >
                    <template v-if="getIsHasExOrBackComment(part.id).ex || getIsHasExOrBackComment(part.id).back">
                      {{ getStockCommentForBackOrEx(part.id) }}
                    </template>
                    <template v-else>
                      <template v-if="getStockName(part.id) === 'In Stock'">
                        In Stock
                        <br v-if="!isEmpty(getStockComment(part.id))"/>
                      </template>
                      {{ getStockComment(part.id) }}
                    </template>
                  </div>
                </b-td>

                <b-td class="part-list-rrp text-right align-top">
                    <div class="part-list-item-rrp">{{ part.rrp | formatMoney }}</div>
                </b-td>
                <b-td class="part-list-qty text-center align-top">
                    <div class="part-list-item-qty font-12">
                        {{ !(partIsLinked(part) && partIsWithNoCost(part)) ? part.qty : '' }}
                    </div>
                </b-td>
                <b-td class="part-list-supplier text-center align-top"
                      v-for="supplier in supplierPrice.selectedSuppliers"
                      :key="supplier.orderId"
                      :class="{'offer-checked' : supplier.isPartChecked(part.id) }">

                    <template v-if="part.isOriginalPart ">
                        <div class="part-list-item-price part-list-item-price--priced font-12 text-right"
                            v-if="supplier.isPartCreated(part.id)"
                            :class="{'has-icon': !partIsWithCost(part) && (supplier.parts[part.id] && (supplier.parts[part.id].flagged || supplier.parts[part.id].comment > 0))}"
                            @click="checkOfferForOrder(part.id, supplier.parts[part.id].id)">
                            <div class="part-list-part-name__icon-group">
                                <i v-if="partIsLinked(part)"
                                    class='bx bx-link part-list-part-name__icon'
                                    v-b-tooltip.hover="{customClass: 'ps-tooltip', html: true, title:`Linked to <br>${getPartLinkedName(part)}`, placement:'leftbottom'}"
                                    ></i>
                            </div>
                            <div class="part-list-item-price__value">
                                <template v-if="partIsLinked(part) && partIsWithNoCost(part) && (supplier.type == 'OEM' || supplier.type == 'OEM-GEN' || supplier.type == 'OEM-PAR')">Linked</template>
                              <template v-else-if="supplier.isPartSelected(part.id)
                                                     && supplier.type == 'OEM'
                                                     && supplier.getPart(part.id).rebate
                                                     && supplier.getPart(part.id).rebate > 0
                                                     && supplier.getPart(part.id).rebate < supplier.getPart(part.id).price"
                              >
                                {{ supplier.getPart(part.id).rebate | formatMoney }}
                              </template>
                                <template v-else-if="supplier.isPartSelected(part.id)">{{ supplier.getPart(part.id).price | formatMoney }}</template>
                                <template v-else></template>
                            </div>

                            <!-- icon group -->
                          <template >
                            <div v-if="supplier.isPartChecked(part.id)" class="part-list-item-price__icon-group" :class="{'two-icons-group': supplier.getOffer(part) && supplier.getOffer(part).nonReturnable}">
                              <i class="font-20"
                                 v-if="part.stock[supplier.rfqToSupplierId] >= 0 || part.stock[supplier.rfqToSupplierId] <= 7"
                                 :class="{
                                      'transparent-icon bx bx-check-circle': part.stock[supplier.rfqToSupplierId] === 0,
                                    // In Stock
                                    'bx bx-check-circle green-icon': part.stock[supplier.rfqToSupplierId] === 1,
                                    // EX Warehouse
                                    'bx bx-check-circle orange-icon': part.stock[supplier.rfqToSupplierId] === 6,
                                    'bx bx-check-circle icon-orange-blinking': part.stock[supplier.rfqToSupplierId] === 6 && getStockComment(part.id),
                                    // Low Stock
                                    'bx bx-check-circle blue-icon': part.stock[supplier.rfqToSupplierId] === 2,
                                    // No Stock, No Longer Available, Not Applicable
                                    'bx bx-minus-circle gray-icon': part.stock[supplier.rfqToSupplierId] === 3 || part.stock[supplier.rfqToSupplierId] === 5 || part.stock[supplier.rfqToSupplierId] === 7,
                                    // Back Order
                                    'bx bx-check-circle red-icon': part.stock[supplier.rfqToSupplierId] === 4,
                                    'bx bx-check-circle red-icon icon-red-blinking': part.stock[supplier.rfqToSupplierId] === 4 && getStockComment(part.id),
                                  }"
                                 v-b-tooltip.hover="{customClass: 'ps-tooltip custom-tooltip-position', html: true, title: getPartTooltip(supplier.getOffer(part), supplier, part.stock[supplier.rfqToSupplierId]), placement:'leftbottom'}"
                                 style="height: 46px; width: 22px; padding-top: 10px"
                              >
                              </i>
                              <i
                                  v-if="supplier.getOffer(part) && supplier.getOffer(part).nonReturnable"
                                  style="height: 46px; width: 22px; padding-top: 10px;"
                                  v-b-tooltip.hover="{customClass: 'ps-tooltip non-returnable-tooltip', html: true, title: '<b>Marked Non-Returnable Part</b>', placement:'leftbottom'}"
                                  class='bx bx-error font-20 orange-icon'></i>
                            </div>
                          </template>
                        </div>
                    </template>
                    <template v-else-if="part.isOptional && supplier.getOffer(part)">
                        <div
                                class="part-list-item-price font-12 part-list-item-price--priced text-right"
                                :class="{'has-icon': (supplier.getOffer(part).flagged || supplier.getOffer(part).comment.length > 0)}">
                            <div class="part-list-item-price__value">
                                {{supplier.getOffer(part).price | formatMoney }}
                            </div>

                            <!-- icon group -->
                            <div v-if="supplier.isPartChecked(part.id)" class="part-list-item-price__icon-group" :class="{'two-icons-group': supplier.getOffer(part) && supplier.getOffer(part).nonReturnable}">
                              <i class="font-20"
                                 v-if="part.stock[supplier.rfqToSupplierId] >= 0 || part.stock[supplier.rfqToSupplierId] <= 7"
                                 :class="{
                                      'transparent-icon bx bx-check-circle': part.stock[supplier.rfqToSupplierId] === 0,
                                    // In Stock
                                    'bx bx-check-circle green-icon': part.stock[supplier.rfqToSupplierId] === 1,
                                    // EX Warehouse
                                    'bx bx-check-circle orange-icon': part.stock[supplier.rfqToSupplierId] === 6,
                                    'bx bx-check-circle icon-orange-blinking': part.stock[supplier.rfqToSupplierId] === 6 && getStockComment(part.id),
                                    // Low Stock
                                    'bx bx-check-circle blue-icon': part.stock[supplier.rfqToSupplierId] === 2,
                                    // No Stock, No Longer Available, Not Applicable
                                    'bx bx-minus-circle gray-icon': part.stock[supplier.rfqToSupplierId] === 3 || part.stock[supplier.rfqToSupplierId] === 5 || part.stock[supplier.rfqToSupplierId] === 7,
                                    // Back Order
                                    'bx bx-check-circle red-icon': part.stock[supplier.rfqToSupplierId] === 4,
                                    'bx bx-check-circle red-icon icon-red-blinking': part.stock[supplier.rfqToSupplierId] === 4 && getStockComment(part.id),
                                  }"
                                 v-b-tooltip.hover="{customClass: 'ps-tooltip custom-tooltip-position', html: true, title: getPartTooltip(supplier.getOffer(part), supplier, part.stock[supplier.rfqToSupplierId]), placement:'leftbottom'}"
                                 style="height: 46px; width: 22px; padding-top: 10px"
                              >
                              </i>
                              <i
                                  v-if="supplier.getOffer(part) && supplier.getOffer(part).nonReturnable"
                                  style="height: 46px; width: 22px; padding-top: 10px;"
                                  v-b-tooltip.hover="{customClass: 'ps-tooltip non-returnable-tooltip', html: true, title: '<b>Marked Non-Returnable Part</b>', placement:'leftbottom'}"
                                  class='bx bx-error font-20 orange-icon'></i>
                            </div>
                        </div>
                    </template>
                    <template v-else>
                        <div class="part-list-item-price part-list-item-price--priced font-12 text-right"
                            v-if="supplier.isPartCreated(part.id)"
                            :class="{'has-icon':(supplier.parts && supplier.parts[part.id] && (supplier.parts[part.id].flagged || supplier.parts[part.id].comment > 0))}"
                            @click="checkOfferForOrder(part.id, supplier.parts[0][part.id].id)">
                           <div class="part-list-part-name__icon-group">
                                <i v-if="partIsLinked(part)"
                                    class='bx bx-link part-list-part-name__icon'
                                    v-b-tooltip.hover="{customClass: 'ps-tooltip', html: true, title:`Linked to <br>${getPartLinkedName(part)}`, placement:'leftbottom'}"
                                    ></i>
                            </div>
                            <div class="part-list-item-price__value pr-0">
                                <template v-if="partIsLinked(part) && partIsWithNoCost(part) && (supplier.type == 'OEM-GEN' || supplier.type == 'OEM-PAR')">
                                    <div class="text-center">Linked</div>
                                </template>
                                <template v-else-if="supplier.isPartSelected(part.id)
                                                     && supplier.getPart(part.id).rebate
                                                     && supplier.getPart(part.id).rebate > 0
                                                     && supplier.getPart(part.id).rebate < supplier.getPart(part.id).price"
                                >
                                  {{ supplier.getPart(part.id).rebate | formatMoney }}
                                </template>
                              <template v-else-if="supplier.isPartSelected(part.id)">
                                    <div class="part-list-item-price__value-padding">{{ supplier.getPart(part.id).price | formatMoney }}</div>
                                </template>
                                <template v-else></template>
                            </div>

                            <!-- icon group -->
                            <div v-if="supplier.isPartChecked(part.id)" class="part-list-item-price__icon-group" :class="{'two-icons-group': supplier.getOffer(part) && supplier.getOffer(part).nonReturnable}">
                              <i class="font-20"
                                 v-if="part.stock[supplier.rfqToSupplierId] >= 0 || part.stock[supplier.rfqToSupplierId] <= 7"
                                 v-b-tooltip.hover="{customClass: 'ps-tooltip custom-tooltip-position', html: true, title: getPartTooltip(supplier.getOffer(part), supplier, part.stock[supplier.rfqToSupplierId]), placement:'leftbottom'}"
                                 :class="{
                                      'transparent-icon bx bx-check-circle': part.stock[supplier.rfqToSupplierId] === 0,
                                    // In Stock
                                    'bx bx-check-circle green-icon': part.stock[supplier.rfqToSupplierId] === 1,
                                    // EX Warehouse
                                    'bx bx-check-circle orange-icon': part.stock[supplier.rfqToSupplierId] === 6,
                                    'bx bx-check-circle icon-orange-blinking': part.stock[supplier.rfqToSupplierId] === 6 && getStockComment(part.id),
                                    // Low Stock
                                    'bx bx-check-circle blue-icon': part.stock[supplier.rfqToSupplierId] === 2,
                                    // No Stock, No Longer Available, Not Applicable
                                    'bx bx-minus-circle gray-icon': part.stock[supplier.rfqToSupplierId] === 3 || part.stock[supplier.rfqToSupplierId] === 5 || part.stock[supplier.rfqToSupplierId] === 7,
                                    // Back Order
                                    'bx bx-check-circle red-icon': part.stock[supplier.rfqToSupplierId] === 4,
                                    'bx bx-check-circle red-icon icon-red-blinking': part.stock[supplier.rfqToSupplierId] === 4 && getStockComment(part.id),
                                  }"
                                 style="height: 46px; width: 22px; padding-top: 10px"
                              >
                              </i>
                              <i
                                  v-if="supplier.getOffer(part) && supplier.getOffer(part).nonReturnable"
                                  style="height: 46px; width: 22px; padding-top: 10px;"
                                  v-b-tooltip.hover="{customClass: 'ps-tooltip non-returnable-tooltip', html: true, title: '<b>Marked Non-Returnable Part</b>', placement:'leftbottom'}"
                                  class='bx bx-error font-20 orange-icon'></i>

                            </div>
                        </div>
                    </template>
                </b-td>
            </b-tr>
            <b-tr>
                <b-td class="subheader parts-footer text-right" colspan="5">Delivery Instruction<span
                    class="subheader-border-right"></span></b-td>
                <b-td class="footer-value font-12 text-center" v-for="supplier in supplierPrice.selectedSuppliers"
                      :key="supplier.orderId">
                      <multiselect
                        v-model="supplier.deliveryType"
                        :options="deliveredInstruction"
                        :showLabels="false"
                        :option-height="29"
                        :max-height="203"
                        :close-on-select="true"
                        :preselect-first="true"
                        :allow-empty="false"
                        :searchable="false"
                        class="order-list-multiselect">
                </multiselect>
                </b-td>
            </b-tr>
            <b-tr>
                <b-td class="subheader parts-footer text-right" colspan="5">Payment Terms<span
                    class="subheader-border-right"></span></b-td>
                <b-td class="footer-value font-12 text-center" v-for="supplier in supplierPrice.selectedSuppliers"
                      :key="supplier.orderId">
                      <multiselect
                        v-model="paymentTerms[supplier.id]"
                        :options="paymentTypes"
                        :showLabels="false"
                        :option-height="29"
                        :max-height="203"
                        :close-on-select="true"
                        track-by="value"
                        label="value"
                        placeholder="Select"
                        class="order-list-multiselect">
                      </multiselect>
                </b-td>
            </b-tr>
            <b-tr>
                <b-td class="subheader parts-footer text-right" colspan="5">Parts in Stock Today<span
                    class="subheader-border-right"></span></b-td>
                <b-td class="footer-value font-12 text-center" v-for="supplier in supplierPrice.selectedSuppliers"
                      :key="supplier.orderId">
                  <span v-if="rfq.status === 'Ordered'">
                    {{ supplier.inStockWithoutPercentSelected}} / {{ supplier.selectedParts.length }}
                  </span>
                  <span v-else>
                    {{ supplier.inStockWithoutPercent}} / {{ supplier.countPartForInStock }}
                  </span>
<!--                  <span v-if="supplier.inStock !== 1 && supplier.inStock !== 0">only</span>-->
                </b-td>
            </b-tr>
            <b-tr>
                <b-td class="subheader parts-footer text-right" colspan="5">Parts Delivery ETA<span
                    class="subheader-border-right"></span></b-td>
                <b-td class="footer-value font-12 text-center" v-for="supplier in supplierPrice.selectedSuppliers"
                      :key="supplier.orderId"> {{ supplier.partsDeliveryETA }}
                </b-td>
            </b-tr>
            <b-tr>
                <b-td class="subheader parts-footer text-right" colspan="5">Saving<span
                    class="subheader-border-right"></span></b-td>
                <b-td class="footer-value font-12 text-right part-list-footer-value-padding" v-for="supplier in supplierPrice.selectedSuppliers"
                      :key="supplier.orderId">{{ supplier.priceSavingSelected | formatMoney }}
                </b-td>
            </b-tr>
            <b-tr>
                <b-td class="subheader subheader-t parts-footer text-right" colspan="5">Subtotal <span
                    class="subheader-border-right"></span></b-td>
                <b-td class="footer-value font-14 font-inter--semibold text-right part-list-footer-value-padding"
                      v-for="supplier in supplierPrice.selectedSuppliers" :key="supplier.orderId">
                    {{ supplier.orderSubtotal | formatMoney }}
                </b-td>
            </b-tr>
            <b-tr>
                <b-td class="subheader subheader-t parts-footer text-right" colspan="5">GST <span
                        class="subheader-border-right"></span></b-td>
                <b-td class="footer-value font-14 font-inter--semibold text-right part-list-footer-value-padding"
                      v-for="supplier in supplierPrice.selectedSuppliers" :key="supplier.orderId">
                    {{ supplier.orderGst | formatMoney }}
                </b-td>
            </b-tr>
            <b-tr>
                <b-td class="subheader parts-footer text-right" colspan="5">Grand Total<span
                    class="subheader-border-right"></span></b-td>
                <b-td class="footer-value font-14 font-inter--semibold text-right part-list-footer-value-padding"
                      v-for="supplier in supplierPrice.selectedSuppliers" :key="supplier.orderId">
                    {{ supplier.orderTotal | formatMoney }}
                </b-td>
            </b-tr>
            <b-tr>
                <b-td class="subheader parts-footer text-right" colspan="5">Your Rewards<span
                    class="subheader-border-right"></span></b-td>
                <b-td class="footer-value font-12 text-center" v-for="supplier in supplierPrice.selectedSuppliers"
                      :key="supplier.orderId">{{ supplier.reward }}
                </b-td>
            </b-tr>
        </b-tbody>
    </b-table-simple>
</template>

<script>
    /* eslint-disable */
import _ from "lodash";
import Multiselect from 'vue-multiselect'
    import {mapGetters} from "vuex";

    export default {
    name: "RFQ-order-summary",
    components: {
        Multiselect,
    },
    props: [
        'rfq',
        'supplier-price',
        'step',
        'paymentTerms'
        // 'oem-supplier'
    ],
    data() {
        return {
            deliveredInstruction: ['Complete', 'Partial'],
        }
    },
    computed: {
      ...mapGetters({
        paymentTypes: 'paymentTypes',
      }),
        OEMSupplier() {
            return this.supplierPrice.OEMSupplier;
        },
        allParts() {
            let parts = this.supplierPrice.parts ? this.supplierPrice.parts : [];
            let _parts = [];
            _.forEach(parts, (part) => {
                if (!part.isOriginalPart) {
                    let isExistOffer = false;
                    _.forEach(this.selectedParts, (s) => {
                        if (s.id == part.id) {
                            isExistOffer = true;
                            return;
                        }
                    });

                    if (isExistOffer) {
                        _parts.push(part);
                    }
                } else {
                    _parts.push(part);
                }
            });
            return _parts;
        },
        selectedSuppliers() {
            return this.supplierPrice.selectedSuppliers;
        },
        selectedParts() {
          return this.supplierPrice.selectedParts
        },
        allPartsSomebodySelected(){
            if (this.step !== 'summary' && this.rfq.status !== 'Ordered'){
                return this.allParts;
            }
            let parts = _.filter(this.allParts, (part)=>{
                return _.some(this.selectedParts, (sp)=>{
                   return !!(Number(sp.id) == Number(part.id) || Number(part.groupSelectId) == Number(sp.id))
                })
            })
            return parts;
        }
    },
    methods: {
        getPartTooltip (prt, supplier, stockValue) {
          let r = ''
          if (stockValue === 0) {
            r += 'Undefined'
          } else if (stockValue === 1) {
            r += 'In Stock'
          } else if (stockValue === 2) {
            r += 'Low Stock'
          } else if (stockValue === 3) {
            r += 'No Stock'
          } else if (stockValue === 4) {
            r += 'On Back Order'
          } else if (stockValue === 5) {
            r += 'No Longer Avail'
          } else if (stockValue === 6) {
            r += 'Ex Warehouse'
          } else if (stockValue === 7) {
            r += 'Nil Supply'
          }

          let stockComment = _.trim(prt?.stockComment)
          let condition = _.trim(supplier?.getPart(prt?.id)?.condition)
          let comment = ''

          if (stockComment) {
            comment += stockComment
          }
          if (condition) {
            if (stockComment) {
              comment += '<br/>'
            }
            comment += `Condition: ${condition}`
          }

          if (!_.isEmpty(comment)) {
            r += '<br/> ' + comment
          }

          if ((stockValue !== 7 && stockValue !== 3) && this.getPartNumber(prt.originalPartId)) {
            if (!supplier.isSupplierTypeOEMGEN && prt.partNumber !== this.getPartNumber(prt.originalPartId)) {
              r += `<br/> <span>${prt.partNumber}</span>`
            }
            r += `<br/> <strong>${this.getPartNumber(prt.originalPartId)}</strong>`
          }

          if (stockValue === 1 || stockValue === 2 || stockValue === 4 || stockValue === 6) {
            let isHasLinked = false
            let priceWithLinked = parseFloat(prt.price)
            let rrpWithLinked = parseFloat(prt.rrp)
            _.forIn(supplier.parts, (p, pId) => {
              if (Number(pId) === 0) {
                _.forIn(p, (mP) => {
                  if (Number(mP.linkId) > 0 && mP.linkType === 'withCost' && Number(mP.linkId) === Number(prt.id)) {
                    isHasLinked = true
                    if (mP.price > 0) {
                      priceWithLinked += parseFloat(mP.price)
                    }
                    if (mP.rrp > 0) {
                      rrpWithLinked += parseFloat(mP.rrp)
                    }
                  }
                })
              } else if (Number(p.linkId) > 0 && p.linkType === 'withCost' && Number(p.linkId) === Number(prt.id)) {
                isHasLinked = true
                if (p.price > 0) {
                  priceWithLinked += parseFloat(p.price)
                }
                if (p.rrp > 0) {
                  rrpWithLinked += parseFloat(p.rrp)
                }
              }
            })

            if (isHasLinked) {
              r += `<br/>Combined Price: $${priceWithLinked.toFixed(2)}`
              if (rrpWithLinked && priceWithLinked) {
                let profit = parseFloat(((Number.parseFloat(rrpWithLinked).toFixed(2) - Number.parseFloat(priceWithLinked).toFixed(2)) * 100) / priceWithLinked).toFixed(2)
                if (profit > 0) {
                  r += `<br/>Markup: ${profit}% <br>Profit: $${(Number.parseFloat(rrpWithLinked).toFixed(2) - Number.parseFloat(priceWithLinked).toFixed(2)).toFixed(2)}`
                }
              }
            } else {
              let part = _.find(this.allParts, (p) => {
                return Number(p.id) === Number(prt.originalPartId)
              })
              let rrp = part ? part.rrp : prt.rrp
              if (rrp && prt.price) {
                let profit = parseFloat(((Number.parseFloat(rrp).toFixed(2) - Number.parseFloat(prt.price).toFixed(2)) * 100) / prt.price).toFixed(2)
                if (profit > 0) {
                  r += `<br/>Markup: ${profit}% <br>Profit: $${(Number.parseFloat(rrp).toFixed(2) - Number.parseFloat(prt.price).toFixed(2)).toFixed(2)}`
                }
              }
            }
          }
          return r
        },
        getStockCommentForBackOrEx(id) {
          let r = this.getStockComment(id)
          if (_.isEmpty(r)) {
            if (this.getIsHasExOrBackComment(id).ex) {
              return  'EX Warehouse'
            } else {
              return 'On Back Order'
            }
          }
          return r
        },
        getIsHasExOrBackComment(partId) {
          return this.supplierPrice.getIsHasExOrBackComment(partId)
        },
        getStockCommentFull(partId) {
          return this.supplierPrice?.getStockCommentForAll(partId)
        },
        getStockName(partId) {
          return this.supplierPrice?.getStockName(partId)
        },
        getStockComment(partId) {
          let result = _.trim(this.supplierPrice?.getStockCommentForAll(partId))?.substr(0, 15);
          if (this.supplierPrice?.getStockCommentForAll(partId)?.length > 15) {
            result += '...'
          }
          return result
        },
        isEmpty(value) {
          return _.isEmpty(value)
        },
        partIsLinked(part) {
            return  this.supplierPrice.partIsLinked(part);
        },
        partIsWithNoCost (part) {
          return this.supplierPrice.partIsWithNoCost(part)
        },
        partIsWithCost (part) {
          return this.supplierPrice.partIsWithCost(part)
        },
        getAltPartName(partId) {
            return this.supplierPrice.getAltPartName(partId);
        },
        getPartLinkedName (part) {
          return this.supplierPrice.getPartLinkedName(part)
        },
        getPartNumber(partId) {
            return this.supplierPrice.getPartNumber(partId);
        },
        getStockLabel(part) {
            return part.selectedOption ? part.selectedOption.label : '';
        },
        checkOfferForOrder(repairerPartId, supplierPartId) {
            this.$emit('check-offer', repairerPartId, supplierPartId);
        }
    }
}
</script>

<style lang="scss">
    .rfq-order-page {
        .table-responsive {
            // Hide scrollbar for IE and Edge
            -ms-overflow-style: none;

            // hide scroll on firefox
            scrollbar-width: none;

            &::-webkit-scrollbar {
                display: none;
            }
        }
        .table {
            margin-bottom: 36.5px;
            color: unset;
        }
        .table.b-table>thead>tr {
            color: unset !important;
        }
        .supplier-icon {
            opacity: 0.5;
            color: #1B1E38;
        }
        .part-list-supplier {
            box-sizing: border-box;
            font-weight: bold;
        }

        .part-list-part-name {
            &__alt {
                opacity: 0.5;
            }
        }

        .part-list-line {
            padding: 0.75rem 5px !important;
        }

        .sort-icon,
        .part-list-part-name span,
        .part-list-qty span {
            background-image: url(data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB3aWR0aD0iOHB4IiBoZWlnaHQ9IjE2cHgiIHZpZXdCb3g9IjAgMCA4IDE2IiB2ZXJzaW9uPSIxLjEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiPgogICAgPHRpdGxlPkZEQkU4QzkxLTRDNDMtNDNBMi04ODM3LTQ3RDMyMkNCMTVGNTwvdGl0bGU+CiAgICA8ZyBpZD0iVUktRGVzaWduIiBzdHJva2U9Im5vbmUiIHN0cm9rZS13aWR0aD0iMSIgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJldmVub2RkIiBvcGFjaXR5PSIwLjI1Ij4KICAgICAgICA8ZyBpZD0iRGFzaGJvYXJkLVBhcnRzZWFyY2gtKEVkaXQtU3VibWl0dGVkLVF1b3RlcyktUGFydC1MaXN0LURldGFpbHMiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC01MTMuMDAwMDAwLCAtNDAxLjAwMDAwMCkiIGZpbGw9IiMxQjFFMzgiIGZpbGwtcnVsZT0ibm9uemVybyI+CiAgICAgICAgICAgIDxnIGlkPSJNYWluIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgyNTAuMDAwMDAwLCAxNDguMDAwMDAwKSI+CiAgICAgICAgICAgICAgICA8ZyBpZD0iTnVtYmVyIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgyMzYuMDAwMDAwLCAyNTMuMDAwMDAwKSI+CiAgICAgICAgICAgICAgICAgICAgPGcgaWQ9ImFycm93cy12IiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgyNy4wMDAwMDAsIDAuMDAwMDAwKSI+CiAgICAgICAgICAgICAgICAgICAgICAgIDxwYXRoIGQ9Ik0zLjIzODg2NTUxLDEzLjI2NTA5NjUgTDMuMjM4ODY1NTEsMi43MzM5MDQwMiBMMS4zMDg2Mjg0Myw0Ljc2MzQ0NDMxIEMxLjAwOTk3NTMyLDUuMDY2ODUyMzQgMC41MzUyNTEyNTMsNS4wNjI1MTMxOCAwLjI0MTY1NTk1Myw0Ljc1MzY5MTc3IEMtMC4wNTE5MzkzNDY0LDQuNDQ0ODcwMzUgLTAuMDU2MDY0NTcwMywzLjk0NTUyNjY3IDAuMjMyMzg0MjUxLDMuNjMxMzg1MTUgTDMuNDYxODc3OTEsMC4yMzQ0MDcwNjMgQzMuNzU5MTAwODIsLTAuMDc4MTM1Njg3NiA0LjI0MDg5OTE4LC0wLjA3ODEzNTY4NzYgNC41MzgxMjIwOSwwLjIzNDQwNzA2MyBMNy43Njc2MTU3NSwzLjYzMTM4NTE1IEM3Ljk2NTQ3NzY3LDMuODMyMzk3MjggOC4wNDQ4MzA1Miw0LjEzMDA2NTkzIDcuOTc1MTc0OTYsNC40MDk5ODE5MSBDNy45MDU1MTk0LDQuNjg5ODk3ODkgNy42OTc2OTU0Niw0LjkwODQ5OTc3IDcuNDMxNTgwNDQsNC45ODE3Njc3MiBDNy4xNjU0NjU0Miw1LjA1NTAzNTY4IDYuODgyNDczMDEsNC45NzE1Njc1MyA2LjY5MTM3MTU3LDQuNzYzNDQ0MzEgTDQuNzYxMTM0NDksMi43MzQ3MDQ2MyBMNC43NjExMzQ0OSwxMy4yNjU4OTcxIEw2LjY5MTM3MTU3LDExLjIzNTU1NjIgQzYuODgyNDczMDEsMTEuMDI3NDMzIDcuMTY1NDY1NDIsMTAuOTQzOTY0OCA3LjQzMTU4MDQ0LDExLjAxNzIzMjggQzcuNjk3Njk1NDYsMTEuMDkwNTAwOCA3LjkwNTUxOTQsMTEuMzA5MTAyNiA3Ljk3NTE3NDk2LDExLjU4OTAxODYgQzguMDQ0ODMwNTIsMTEuODY4OTM0NiA3Ljk2NTQ3NzY3LDEyLjE2NjYwMzIgNy43Njc2MTU3NSwxMi4zNjc2MTU0IEw0LjUzODEyMjA5LDE1Ljc2NDU5MzUgQzQuMzk1Njg3MDksMTUuOTE1Mjc1MiA0LjIwMjAxMjQzLDE2IDQsMTYgQzMuNzk3OTg3NTcsMTYgMy42MDQzMTI5MSwxNS45MTUyNzUyIDMuNDYxODc3OTEsMTUuNzY0NTkzNSBMMC4yMzIzODQyNTEsMTIuMzY2ODE0OCBDMC4wMzQ1MjIzMjc0LDEyLjE2NTgwMjYgLTAuMDQ0ODMwNTIwMiwxMS44NjgxMzQgMC4wMjQ4MjUwMzg0LDExLjU4ODIxOCBDMC4wOTQ0ODA1OTcxLDExLjMwODMwMiAwLjMwMjMwNDUzNSwxMS4wODk3MDAxIDAuNTY4NDE5NTU2LDExLjAxNjQzMjIgQzAuODM0NTM0NTc3LDEwLjk0MzE2NDIgMS4xMTc1MjY5OSwxMS4wMjY2MzI0IDEuMzA4NjI4NDMsMTEuMjM0NzU1NiBMMy4yMzg4NjU1MSwxMy4yNjUwOTY1IFoiIGlkPSJQYXRoIj48L3BhdGg+CiAgICAgICAgICAgICAgICAgICAgPC9nPgogICAgICAgICAgICAgICAgPC9nPgogICAgICAgICAgICA8L2c+CiAgICAgICAgPC9nPgogICAgPC9nPgo8L3N2Zz4=);
            height: 16px;
            width: 8px;
            display: inline-block;
            cursor: pointer;
            margin-left: 5px;
        }
        .offer-checked {
            border: 1px solid rgba(46, 169, 255, 0.1);
            background-color: rgba(46,169,255,0.1);
        }
        .subheader.parts-footer {
            opacity: 0.5;
            color: #1C1F39;
            font-size: 12px;
            font-weight: bold;
            letter-spacing: 0;
            line-height: 25px;
            padding-left: 40%;
        }

        .supplier-count-4 {
            .subheader.parts-footer {
                padding-left: 20%;
            }
        }

        .supplier-count-5 {
          .subheader.parts-footer {
            padding-left: 20%;
          }
        }


        // column width
        .tab-content-table table tr td {
            padding: 10px 5px;
        }
        .part-list {
            &-part-name {
                min-width: 200px;
                width: 40%;
            }
            &-number {
                min-width: 145px;
                max-width: 145px;
                width: 10%;
                overflow: scroll;
                padding: 0.75rem 10px !important;
            }
            &-rrp {
                width: 10%;
            }
            &-qty {
                width: 5%;
            }
            &-supplier {
                min-width: 110px;
                width: 5%;
            }
        }
        .wizard__body {
            width: 694px;
        }

        .subheader-border-right {
            border-right: 1px solid rgba(27, 30, 56, 0.2);
            width: 1px;
            float: right;
            height: 25px;
            margin-left: 30px;
        }

    }
</style>

<style scoped>
.green-icon {
  color: rgb(60, 199, 169) !important;
}

.orange-icon {
  color: orange;
}

.icon-orange-blinking {
  animation: blinking-orange 1s linear infinite;
  animation-duration: 2s;
  animation-iteration-count: infinite;
  animation-delay: 250ms;
}

@keyframes blinking-orange {
  20% {
    opacity: 1;
  }
  50% {
    opacity: 0;
  }
  80% {
    opacity: 1;
  }
}

.blue-icon {
  color: #2f6da5 !important;
}

.gray-icon {
  color: rgb(121, 121, 121) !important;
}

.icon-red-blinking {
  color: red;
  animation: blinking-red 1s linear infinite;
  animation-duration: 2s;
  animation-iteration-count: infinite;
  animation-delay: 250ms;
}

@keyframes blinking-red {
  20% {
    opacity: 1;
  }
  50% {
    opacity: 0;
  }
  80% {
    opacity: 1;
  }
}

.supplier-count-1 .rfq-order-step-3{
width: 1000px;
}
.supplier-count-2 .rfq-order-step-3{
  width: 1170px;
}
.supplier-count-3 .rfq-order-step-3{
  width: 1270px;
}
.supplier-count-4 .rfq-order-step-3{
  width: 1390px;
}
.supplier-count-5 .rfq-order-step-3{
  width: 1490px;
}
.part-number-stock-orange {
  color: #F59345 !important;
  font-weight: 600;
  width: auto;
  white-space: nowrap;
  animation: blinking-orange 1s linear infinite;
  animation-duration: 2s;
  animation-iteration-count: infinite;
  animation-delay: 250ms;
}

.part-number-stock-red {
  color: red;
  font-weight: 600;
  width: auto;
  white-space: nowrap;
  animation: blinking-red 1s linear infinite;
  animation-duration: 2s;
  animation-iteration-count: infinite;
  animation-delay: 250ms;
}

@keyframes blinking-orange {
  20% {
    opacity: 1;
  }
  50% {
    opacity: 0;
  }
  80% {
    opacity: 1;
  }
}

@keyframes blinking-red {
  20% {
    opacity: 1;
  }
  50% {
    opacity: 0;
  }
  80% {
    opacity: 1;
  }
}

.order-list-multiselect {
    min-width: 100px;
    width: 100px;
}
.order-list-multiselect >>> .multiselect__single{
min-width: 60px;
}
  .rfq-order-page .part-list-item-price {
  padding-top: 5px;
}
  .rfq-order-page .part-list-item-price__value {
    padding: 0 5px !important;
}

  .rfq-order-page .part-list-footer-value-padding {
    padding-right: 40px;
}

  .rfq-order-page .part-list-number {
    font-weight: 600 !important;
}
</style>
